export default "__VITE_ASSET__O8OhFtIf__"